<template>
  <el-select
    :value="value"
    size="small"
    filterable
    clearable
    :collapse-tags="collapseTags"
    :loading="loading"
    @change="handleChange"
    remote
    :remote-method="requestData"
    placeholder="搜索并选择"
    style="width: 100%"
    multiple
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.code"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { productList } from '@/service/getData'

export default {
  props: {
    value: {
      type: Array,
      value: [],
    },
    templateId: {
      type: Number,
      default: 0,
    },
    baseId: {
      type: Number,
      default: 0,
    },
    wellId: {
      type: Number,
      default: 0,
    },
    modelNumber: String,
    collapseTags: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData(query) {
      if (query == '') return
      this.loading = true
      let model_number = query || this.modelNumber
      let data = {
        transfer_list: true,
        base_id: this.baseId,
        drill_well_id: this.wellId,
        product_template_id: this.templateId,
        size: 20,
      }

      if (this.wellId) {
        if (!model_number) {
          data.ids = this.value.join('&ids=')
        } else {
          data.code = model_number
        }
      } else {
        data.model_number = model_number
      }

      let res = await productList(data)
      this.loading = false
      this.lists = res.data.list.map((item) => {
        let code = item.code
        if (this.modelNumber) {
          let m = item.custom_params.find((item) => item.label === '型号')
          if (m) {
            code += `（${m.value}）`
          }
        } else {
          code += `（${item.name}）`
        }
        return { id: item.id, code: code }
      })
    },
  },
}
</script>